const SAFE_APOLLO_RESET = '@auth/SAFE_APOLLO_RESET'
const SAFE_APOLLO_RESET_DONE = '@auth/SAFE_APOLLO_RESET_DONE'
const READY_TO_RESET = '@auth/READY_TO_RESET'

export {
  SAFE_APOLLO_RESET,
  SAFE_APOLLO_RESET_DONE,
  READY_TO_RESET
}
